import { gql } from '@apollo/client';
import { SERVICE_PROVIDER } from '../fragments';

export const UPSERT_SERVICE_PROVIDER = gql`
  mutation upsertServiceProvider($input: UpsertServiceProviderInput!) {
    serviceProvider: upsertServiceProvider(input: $input) {
      ...serviceProvider
      funder {
        id
        name
      }
      geographies {
        id
        fromDate
        toDate
        programme {
          id
          name
        }
        district {
          id
          name
        }
        region {
          id
          name
        }
        province {
          id
          name
        }
        country {
          id
          name
        }
        localMunicipality {
          id
          localMunicipality
        }
        districtMunicipality {
          id
          name
        }
        city {
          id
          name
        }
        name
      }
      organisationUsersAddOns {
        id
        name
      }
      organisationUsersPlan {
        id
        name
      }
      programmes {
        id
        name
      }
    }
  }
  ${SERVICE_PROVIDER}
`;
